import { LEAReferralType } from '../../pages/referral/type';
import { ApiMessage, ApiResponseHandler } from '../ApiResponseHandler';
import { REFERRAL_PROGRAM_KEY, THOM_BASE_URL } from '../Constant';
import ThomApiClient from '../ThomApiClient';

export const getLEAPreschoolInfo = async (
  employeeId: string,
  clientId: string,
  consentId?: string,
): Promise<LEAReferralType> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<LEAReferralType>(
      `lea-referrals?employeeId=${employeeId}&clientId=${clientId}&consentId=${
        consentId ?? ''
      }&referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};

export const updateLEAPreschoolInfo = async (
  employeeId: string,
  clientId: string,
  requestBody: LEAReferralType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<LEAReferralType, ApiMessage>(
      `lea-referrals?employeeId=${employeeId}&clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      requestBody,
    ),
  );
};

export const downloadLeaPreSchool = async (
  employeeId: string,
  clientId: string,
  localTimeZone: string,
  consentId?: string,
  language = 'en',
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `lea-referrals/download?employeeId=${employeeId}&consentId=${consentId}&clientId=${clientId}&timezone=${localTimeZone}&referralProgramId=${
        referralProgramId ?? ''
      }&language=${language}`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};
